import { Link } from 'react-router-dom';
import { useLanguage } from '../../../context/LanguageContext';

function Footer() {
  const { t, translate } = useLanguage();
  return (
    <footer className="site-footer">
      <div className="container site-footer__grid">
        <section className="site-footer__column site-footer__brand">
          <Link aria-label="Sanjeevi Grace Herbals home" className="site-footer__brand-lockup" to="/"><img alt="" className="site-footer__logo" src="/assets/logo/logo.jpeg" /><h2>Sanjeevi Grace Herbals</h2></Link>
          <p className="site-footer__brand-description">{translate('Traditional Siddha and herbal wellness solutions focused on quality, purity and trusted care.')}</p>
        </section>

        <section className="site-footer__column">
          <h2>{translate('Explore')}</h2>
          <ul>
            <li><Link to="/shop">{t('shop')}</Link></li>
            <li><Link to="/categories">{t('categories')}</Link></li>
            <li><Link to="/about">{t('about')}</Link></li>
            <li><Link to="/contact">{t('contact')}</Link></li>
            <li><Link to="/track-order">{t('trackOrder')}</Link></li>
          </ul>
        </section>

        <section className="site-footer__column">
          <h2>{translate('Customer Care')}</h2>
          <ul className="site-footer__contacts">
            <li><a href="tel:+917530037100"><strong>{translate('Primary Support')}</strong><span>+91 75300 37100</span></a></li>
            <li><a href="tel:+918825872604"><strong>{translate('Alternate Contact')}</strong><span>+91 88258 72604</span></a></li>
            <li><a href="mailto:customersupport@sanjeevigraceherbals.com"><strong>{translate('Customer Support')}</strong><span className="site-footer__email">customersupport@sanjeevigraceherbals.com</span></a></li>
            <li><a href="mailto:sales@sanjeevigraceherbals.com"><strong>{translate('Sales Enquiries')}</strong><span className="site-footer__email">sales@sanjeevigraceherbals.com</span></a></li>
            <li><a href="mailto:complaints@sanjeevigraceherbals.com"><strong>{translate('Complaints')}</strong><span className="site-footer__email">complaints@sanjeevigraceherbals.com</span></a></li>
          </ul>
        </section>

        <section className="site-footer__column">
          <h2>{translate('Policies')}</h2>
          <ul>
            <li><Link to="/shipping-policy">{translate('Shipping Policy')}</Link></li>
            <li><Link to="/cancellation-policy">{translate('Cancellation Policy')}</Link></li>
            <li><Link to="/return-refund-policy">{translate('Return and Refund Policy')}</Link></li>
            <li><Link to="/privacy">{translate('Privacy Policy')}</Link></li>
            <li><Link to="/terms">{translate('Terms and Conditions')}</Link></li>
            <li><Link to="/medical-disclaimer">{translate('Medical Disclaimer')}</Link></li>
          </ul>
        </section>

        <section className="site-footer__column">
          <h2>{translate('Business Address')}</h2>
          <address className="site-footer__address">
            Door No. 69/4/1C/2,<br />
            Vigneshwara Nagar,<br />
            Thanthonimalai,<br />
            Karur &ndash; 639005,<br />
            Tamil Nadu, India
          </address>
          <a href="https://www.instagram.com/sanjeevigraceherbals/" rel="noopener noreferrer" target="_blank">Instagram: @sanjeevigraceherbals</a>
        </section>
      </div>

      <div className="container site-footer__bottom">
        <p>&copy; 2026 Sanjeevi Grace Herbals. {translate('All rights reserved.')}</p>
      </div>
    </footer>
  );
}

export default Footer;
